import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f61a5ffa&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f61a5ffa')) {
      api.createRecord('f61a5ffa', component.options)
    } else {
      api.reload('f61a5ffa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f61a5ffa&", function () {
      api.rerender('f61a5ffa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/baseInformation/WuyeZiyuanManager/pakinglotoa/index.vue"
export default component.exports